/**
 * @generated SignedSource<<a6d591ad059e2f1efec8d6d4b31fc8a8>>
 * @relayHash e879c948979f03bca0688aee31009d99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 33df597fc5c9095dd58a558ee2d3cf360ce56b3aa5aa364da252f0ea2f87bf21

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null | undefined;
  userId: string;
};
export type ThreadsV2_Query$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
  isEnabled: boolean;
  suggestedActionsV2Enabled: boolean;
};
export type ThreadsV2_Query$data = {
  readonly convoai_homeThreads?: {
    readonly " $fragmentSpreads": FragmentRefs<"RecommendedFeedInternal_AtlassianRecommendedFeed">;
  } | null | undefined;
};
export type ThreadsV2_Query = {
  response: ThreadsV2_Query$data;
  variables: ThreadsV2_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suggestedActionsV2Enabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "ConvoAiHomeThreadsThirdPartySource"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = [
  (v4/*: any*/),
  (v8/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v2/*: any*/)
],
v10 = {
  "concreteType": "ConfluenceBodies",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 300
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:300)"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v12 = [
  (v3/*: any*/)
],
v13 = [
  (v8/*: any*/),
  {
    "concreteType": "ConfluenceUserInfo",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      (v2/*: any*/)
    ]
  },
  {
    "concreteType": "ConfluenceContentVersion",
    "kind": "LinkedField",
    "name": "latestVersion",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "createdAt"
      }
    ]
  },
  (v10/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v3/*: any*/),
          (v11/*: any*/)
        ],
        "type": "ConfluencePage"
      },
      {
        "kind": "InlineFragment",
        "selections": (v12/*: any*/),
        "type": "ConfluenceBlogPost"
      },
      {
        "kind": "InlineFragment",
        "selections": (v12/*: any*/),
        "type": "ConfluenceWhiteboard"
      },
      (v7/*: any*/)
    ]
  }
],
v14 = [
  {
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": (v9/*: any*/)
  },
  {
    "kind": "ScalarField",
    "name": "updated"
  },
  {
    "kind": "ScalarField",
    "name": "created"
  },
  {
    "concreteType": "JiraRichText",
    "kind": "LinkedField",
    "name": "richText",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraADF",
        "kind": "LinkedField",
        "name": "adfValue",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraAdfToConvertedPlainText",
            "kind": "LinkedField",
            "name": "convertedPlainText",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "plainText"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "text"
          },
          (v2/*: any*/)
        ]
      },
      {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "colorName"
              },
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      },
      (v2/*: any*/)
    ]
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v16 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v15/*: any*/),
        (v8/*: any*/),
        (v2/*: any*/)
      ]
    },
    (v2/*: any*/)
  ]
},
v17 = [
  {
    "concreteType": "ConfluenceUserInfo",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v15/*: any*/),
          (v2/*: any*/)
        ]
      },
      (v2/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "suggestedActionsV2Enabled",
                    "variableName": "suggestedActionsV2Enabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "RecommendedFeedInternal_AtlassianRecommendedFeed"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThreadsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConvoAiHomeThread",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isConvoAiHomeThreadSource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "ari"
                              },
                              (v5/*: any*/)
                            ],
                            "type": "ConvoAiHomeThreadsFirstPartySource"
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "ConvoAiHomeThreadSuggestedAction",
                        "kind": "LinkedField",
                        "name": "suggestedActions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "source",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConvoAiHomeThreadsFirstPartySource"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "action"
                          },
                          {
                            "condition": "suggestedActionsV2Enabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v13/*: any*/),
                                            "type": "ConfluenceFooterComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v13/*: any*/),
                                            "type": "ConfluenceInlineComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v14/*: any*/),
                                            "type": "JiraPlatformComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v14/*: any*/),
                                            "type": "JiraServiceManagementComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v3/*: any*/),
                                              (v16/*: any*/),
                                              (v10/*: any*/),
                                              {
                                                "concreteType": "ConfluencePageVersion",
                                                "kind": "LinkedField",
                                                "name": "latestVersion",
                                                "plural": false,
                                                "selections": (v17/*: any*/)
                                              },
                                              (v11/*: any*/)
                                            ],
                                            "type": "ConfluencePage"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v3/*: any*/),
                                              (v16/*: any*/),
                                              (v10/*: any*/),
                                              {
                                                "concreteType": "ConfluenceBlogPostVersion",
                                                "kind": "LinkedField",
                                                "name": "latestVersion",
                                                "plural": false,
                                                "selections": (v17/*: any*/)
                                              }
                                            ],
                                            "type": "ConfluenceBlogPost"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "33df597fc5c9095dd58a558ee2d3cf360ce56b3aa5aa364da252f0ea2f87bf21",
    "metadata": {},
    "name": "ThreadsV2_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "164d0eebed4738877139818c541a2de0";

export default node;
